import { render, staticRenderFns } from "./chat_doctor.vue?vue&type=template&id=302c5c27&scoped=true&"
import script from "./chat_doctor.vue?vue&type=script&lang=js&"
export * from "./chat_doctor.vue?vue&type=script&lang=js&"
import style0 from "./chat_doctor.vue?vue&type=style&index=0&id=302c5c27&scoped=true&lang=scss&"
import style1 from "./chat_doctor.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302c5c27",
  null
  
)

export default component.exports